import { incidentsSlice } from './incidents.slice.ts';

export const { updateDeconIncident } = incidentsSlice.actions;
